import React from 'react'
import { interpolate } from '../utils/proposalVariables'
import { getFrequencyDisplayLabel, isAsNeeded, isIncludedWithPlan } from '../utils/frequencyConfig'
import { getServiceImage } from '../utils/serviceImages'

// Condensed "Your Services in Detail" page: 2-3 services as compact rows
// (thumbnail left; name + frequency badge + description + checklist right).
// The full-page-per-service layout remains available via
// scope.detailRenderMode = 'full'.

const badgeText = (svc) => {
  const freq = getFrequencyDisplayLabel(svc.frequency)
  const included = isIncludedWithPlan(svc.frequency)
  if (included === true) return `${freq} · Included`
  if (included === false) return `${freq} · Add-on`
  // A real cadence (not "As Needed") means the service is part of the plan.
  return isAsNeeded(svc.frequency) ? freq : `${freq} · Included`
}

const checklistItems = (svc) => {
  if (svc.checklist && svc.checklist.length) return svc.checklist.slice(0, 4)
  return (svc.highlights || []).map((h) => h.title).filter(Boolean).slice(0, 4)
}

const CompactServiceDetail = ({ data, variables }) => {
  const services = data?.services || []

  return (
    <div className="proposal-section svc-compact--fill">
      {data?.continued ? (
        <div className="svc-compact__headline-cont">
          Your Services in Detail <span>(continued)</span>
        </div>
      ) : (
        <>
          <div className="proposal-section__headline">Your Services in Detail</div>
          <div className="proposal-section__accent-line" />
        </>
      )}

      <div className="svc-compact__rows">
        {services.map((svc, i) => {
          const img = getServiceImage(svc)
          const items = checklistItems(svc)
          return (
            <div className={'svc-compact__row' + (i === services.length - 1 ? ' is-last' : '')} key={i}>
              {img && (
                <div className="svc-compact__thumb">
                  <img src={img} alt={svc.name} />
                </div>
              )}
              <div className="svc-compact__content">
                <div className="svc-compact__title-row">
                  <div className="svc-compact__title">{svc.name}</div>
                  {svc.frequency && <span className="svc-compact__badge">{badgeText(svc)}</span>}
                </div>
                <div className="svc-compact__desc">
                  {interpolate(svc.shortDescription || svc.description || '', variables)}
                </div>
                {items.length > 0 && (
                  <div className="svc-compact__checklist">
                    {items.map((item, j) => (
                      <div className="svc-compact__check-item" key={j}>
                        <span className="svc-compact__check-icon">&#10003;</span>
                        <span>{interpolate(item, variables)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CompactServiceDetail
